/*
 *
 * Interest reducer
 *
 */

export const Types = {
  // Upload de uma imagem na catergoria
  GET_UPDATE_REQUEST: 'interest/GET_UPDATE_REQUEST',
  GET_UPDATE_SUCCESS: 'interest/GET_UPDATE_SUCCESS',
  GET_UPDATE_FAILURE: 'interest/GET_UPDATE_FAILURE',
};

export const initialState = {
  // Atualiza uma categoria
  interestUpdateLoading: false,
  interestUpdateError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Atualiza um categoria
    case Types.GET_UPDATE_REQUEST:
      return {
        ...state,
        interestUpdateLoading: true,
        interestUpdateError: null,
      };
    case Types.GET_UPDATE_SUCCESS:
      return {
        ...state,
        interestUpdateLoading: false,
        interestUpdateError: null,
      };
    case Types.GET_UPDATE_FAILURE:
      return {
        ...state,
        interestUpdateLoading: false,
        interestUpdateError: action.payload,
      };
    default:
      return state;
  }
};

export const Creators = {
  // Atualiza uma  Categoria
  getInterestUpdateRequest: ({ id, name, status }) => ({
    type: Types.GET_UPDATE_REQUEST,
    payload: {
      id,
      name,
      status,
    },
  }),
  getInterestUpdateSuccess: () => ({
    type: Types.GET_UPDATE_SUCCESS,
  }),
  getInterestUpdateFailure: error => ({
    type: Types.GET_UPDATE_FAILURE,
    payload: error,
  }),
};
